import { FetchStatus } from '@flatsy/types/FetchStatus'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'src/redux'
import { getFilesList } from 'src/redux/slices/Files/Action'
import { selectfiles } from 'src/redux/slices/Files/Selector'
import { UseFiles } from './Type'

export const useFiles = (applicationId: string | undefined): UseFiles => {
  const filesState = useSelector((state: RootState) => state.files)
  const files = useSelector(selectfiles)
  const dispatch = useDispatch()

  const fetch = () => {
    if (applicationId && applicationId !== '') {
      dispatch(getFilesList(applicationId))
    }
  }

  useEffect(() => {
    if (filesState.fetchStatus === FetchStatus.IDLE) {
      fetch()
    }
  }, [filesState.fetchStatus, applicationId])

  return {
    fetch,
    files,
  }
}
